import { Flex, Button } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import MisTiendasDropdown from "../inputs/MisTiendasDropdown";
import TextAreaCustom from "../inputs/TextAreaCustom";
import TextInput from "../inputs/TextInput";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("El nombre es requerido")
    .min(3, "El nombre debe tener al menos 3 caracteres"),
  price: Yup.number()
    .required("El precio es requerido")
    .min(1, "El precio debe ser mayor a 0"),
  description: Yup.string()
    .required("La descripción es requerida")
    .min(10, "La descripción debe tener al menos 10 caracteres")
    .max(100, "La descripción debe tener menos de 100 caracteres"),
  stock: Yup.number()
    .required("El stock es requerido")
    .min(0, "0 es el mínimo de stock"),
  store: Yup.string().required("Selecciona una tienda"),
});

const CreateProductForm = ({savedData, setProductData, productData, nextStep}) => {

  const initialValues = {
    name: savedData ? savedData.name : "",
    price: savedData ? savedData.price : "",
    description: savedData ? savedData.description : "",
    store: savedData ? savedData.stores[0]?._id : "",
    stock: savedData ? savedData.stock : 0,
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        setProductData(values);
        setSubmitting(false);
        nextStep();
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        isValid,
        dirty,
      }) => (
        <Form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Flex
            flexDir="column"
            w="100%"
            justifyContent="center"
            alignItems="center"
            pb="30px"
          >
            <TextInput
              label={"Nombre"}
              type="text"
              name="name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.name}
              errors={errors.name}
              touched={touched.name}
            />
            <TextInput
              label={"Precio"}
              type="number"
              name="price"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.price}
              errors={errors.price}
              touched={touched.price}
            />
            <TextInput
              label={"Stock"}
              type="number"
              name="stock"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.stock}
              errors={errors.stock}
              touched={touched.stock}
            />

            <TextAreaCustom
              label={"Descripción"}
              type="text"
              name="description"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.description}
              errors={errors.description}
              touched={touched.description}
            />

            <MisTiendasDropdown
              label={"Tiendas"}
              name="store"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.store}
              errors={errors.store}
              touched={touched.store}
            />

          <Flex
            w='100%'
            justifyContent='flex-end'
          >
            <Button
              type="submit"
              disabled={isSubmitting || !(isValid)}
            >
              Siguiente
            </Button>
          </Flex>
          </Flex>
        </Form>
      )}
    </Formik>
  );
};

export default CreateProductForm;
